document.addEventListener("DOMContentLoaded", function () {
  const openDrawerButton = document.getElementById("openDrawerButton");
  const closeDrawerButton = document.getElementById("closeDrawerButton");
  const variantDrawer = document.getElementById("variantDrawer");
  const variantItems = document.querySelectorAll(".variant-list .variant-item");
  const variantSelectElement = document.querySelector("variant-selects");
  const addToCartButton = document.getElementById("AddToCart");
  const errorContainer = document.querySelector(".form-notification.error");

  function closeDrawerWithTransition() {
    variantDrawer.classList.remove("open");
    setTimeout(() => {
      variantDrawer.style.right = "-100%";
    }, 300); // Animasyon süresi kadar bekleyin
  }

  function updateAddToCartButton(variant) {
    if (variant && !variant.available) {
      addToCartButton.textContent = window.translationssss.outofstockdrawer || "Stokta Yok";
      addToCartButton.classList.add("sold-out");
      addToCartButton.setAttribute("disabled", "disabled");
    } else if (variant) {
      addToCartButton.textContent = window.translationsss.addtocartdrawer || "Sepete Ekle";
      addToCartButton.classList.remove("sold-out");
      addToCartButton.removeAttribute("disabled");
    }
  }

  // Varsayılan olarak hiçbir bedenin seçili olmamasını sağla
  function clearDefaultSelection() {
    variantItems.forEach(function (item) {
      item.classList.remove("selected");
    });
    openDrawerButton.textContent = window.translationss.sizeSelect || "Beden Seç";
  }

  if (openDrawerButton && closeDrawerButton && variantDrawer) {
    openDrawerButton.addEventListener("click", function () {
      variantDrawer.style.right = "0"; // Drawer'ı görünebilir yap
      setTimeout(() => variantDrawer.classList.add("open"), 10); // Yavaş açılma için
    });

    closeDrawerButton.addEventListener("click", closeDrawerWithTransition);

    document.addEventListener("click", function (event) {
      if (!variantDrawer.contains(event.target) && !openDrawerButton.contains(event.target)) {
        closeDrawerWithTransition();
      }
    });

    variantItems.forEach(function (item) {
      item.addEventListener("click", function () {
        const selectedSize = this.querySelector(".variant-option").textContent.trim();
        const variantId = this.getAttribute("data-variant-id");
        const variantName = window.translationsssss.sizedrawer || "Beden";

        // Seçilen bedenin görselini ve metnini güncelle
        variantItems.forEach(function (item) {
          item.classList.remove("selected");
        });

        this.classList.add("selected");
        openDrawerButton.textContent = `${variantName}: ${selectedSize}`;

        if (variantSelectElement && variantSelectElement.updateVariantInput) {
          const selectedVariant = variantSelectElement.getVariantData().find(variant => variant.id == variantId);
          variantSelectElement.currentVariant = selectedVariant;
          variantSelectElement.updateVariantInput();
          variantSelectElement.updateMedia();
          updateAddToCartButton(selectedVariant);
        }

        // Uyarıyı gizle
        if (errorContainer) {
          errorContainer.style.display = "none";
        }

        closeDrawerWithTransition();
      });
    });

    // İlk yüklemede varsayılan seçimi temizle
    clearDefaultSelection();

    // İlk yüklemede varsayılan varyantın stok durumunu kontrol et
    const defaultVariant = variantSelectElement?.getVariantData()?.find(variant => variant.id == document.querySelector("input[name='id']").value);
    updateAddToCartButton(defaultVariant);

    // Sepete eklemeden önce beden seçilmiş mi kontrol et
    addToCartButton.addEventListener("click", function (event) {
      const selectedVariant = document.querySelector(".variant-list .selected");
      if (!selectedVariant) {
        event.preventDefault();
        if (errorContainer) {
          errorContainer.style.display = "block";
          errorContainer.style.color = "red"; // Uyarı metni kırmızı olacak
          errorContainer.style.fontFamily = "'Futura Book'"; // Yazı tipi 'Futura Book' olacak
          errorContainer.style.fontSize = "16px";
          // Liquid ile aktarılan çeviriyi kullan
          errorContainer.textContent = window.translations.sizeRequired || "Lütfen beden seçiniz!";
        }
      }
    });
  }
});
